<template>
    <!-- Header Section -->
    <div class="row wrapper border-bottom white-bg page-heading">
        <!-- Title on the left -->
        <div class="col-lg-8 align-self-center">
            <h2 class="mb-0">Centralized Dashboard</h2>
        </div>
    </div>
    <div class="wrapper wrapper-content px-0">
        <!-- Header -->
        <!-- <div class="header">
            <div class="header-left">
                <div class="breadcrumb mb-0">
                    <a href="#">Sponsor Dashboard</a>
                    <i class="fa fa-angle-right"></i>
                    <span>All Studies</span>
                </div>

                <div class="comparison-indicator">
                    <i class="fa fa-chart-bar"></i>
                    <span>Comparing 2 studies</span>
                </div>
            </div>

            <div class="header-controls">
                <div class="user-actions">
                    <button class="btn btn-sm btn-outline-primary me-2 py-0">
                        <i class="fa fa-download"></i> Export Portfolio
                    </button>

                    <button class="notification-btn py-0 px-0">
                        <i class="fa fa-bell text-primary"></i>
                        <span class="notification-badge">5</span>
                    </button>
                </div>
            </div>
        </div> -->
        <!-- Global Filters -->
        <!-- <div class="global-filters">
            <div class="filter-group">
                <span class="filter-label">Studies:</span>
                <select id="studyFilter">
                    <option>All Studies</option>
                    <option>Phase 2 Only</option>
                    <option>Phase 3 Only</option>
                    <option>Active Recruiting</option>
                </select>
            </div>

            <div class="filter-group">
                <span class="filter-label">Region:</span>
                <select id="regionFilter">
                    <option>All Regions</option>
                    <option>North America</option>
                    <option>Europe</option>
                    <option>Asia Pacific</option>
                </select>
            </div>

            <div class="filter-group">
                <span class="filter-label">Date Range:</span>
                <input type="date" id="startDate" value="2024-01-01">
                <span>to</span>
                <input type="date" id="endDate" value="2024-06-30">
            </div>

            <div class="filter-group">
                <span class="filter-label">Site Status:</span>
                <select id="siteStatusFilter">
                    <option>All Sites</option>
                    <option>Active Only</option>
                    <option>Delayed Only</option>
                    <option>High Risk Only</option>
                </select>
            </div>

            <div style="margin-left: auto;">
                <button class="btn btn-sm btn-outline-primary me-2 py-0" id="resetFilters">
                    <i class="fa fa-repeat"></i></button>
            </div>
        </div> -->

        <!-- Dashboard Content -->
        <div class="dashboard-content px-0">
            <!-- Portfolio KPIs -->
            <div class="portfolio-kpis">
                <!-- Total Enrollment Progress -->
                <div class="kpi-card" onclick="openDrilldown('enrollment')">
                    <div class="kpi-header">
                        <div class="kpi-title">Total Enrollment Progress</div>
                        <div class="kpi-info" title="Detailed info">
                            <i class="fa fa-info-circle"></i>
                        </div>
                    </div>
                    <div class="kpi-value">{{enrollmentLevelpercentage}}%</div>
                    <div class="kpi-trend trend-positive">
                        <i class="fa fa-arrow-up"></i>
                        <!-- <span>+3.2% vs last month</span> -->
                    </div>
                    <!-- <div class="kpi-progress">
                        <div class="progress-bar">
                            <div class="progress-fill" style="width: 68%"></div>
                        </div>
                        <div class="progress-labels">
                            <span>2,841</span>
                            <span>4,200</span>
                        </div>
                    </div> -->
                </div>

                <!-- Active Studies -->
                <div class="kpi-card" onclick="openDrilldown('studies')">
                    <div class="kpi-header">
                        <div class="kpi-title">Active Studies</div>
                        <div class="kpi-info" title="Detailed info">
                            <i class="fa fa-info-circle"></i>
                        </div>
                    </div>
                    <div class="kpi-value">{{ activeStudies }}</div>
                    <!-- <div class="kpi-trend">
                        <span>4 Phase 2, 8 Phase 3</span>
                    </div>
                    <div class="progress-labels">
                        <span>8 On track</span>
                        <span>4 At risk</span>
                    </div> -->
                </div>

                <!-- Active Sites -->
                <div class="kpi-card" onclick="openDrilldown('sites')">
                    <div class="kpi-header">
                        <div class="kpi-title">Active Sites</div>
                        <div class="kpi-info" title="Detailed info">
                            <i class="fa fa-info-circle"></i>
                        </div>
                    </div>
                    <div class="kpi-value">{{ activeSites }}</div>
                    <!-- <div class="kpi-trend trend-positive">
                        <i class="fa fa-arrow-up"></i>
                        <span>+18 this month</span>
                    </div>
                    <div class="progress-labels">
                        <span>78% recruiting</span>
                        <span>22% pending</span>
                    </div> -->
                </div>

                <!-- High-Risk Studies -->
                <div class="kpi-card" onclick="openDrilldown('risk')">
                    <div class="kpi-header">
                        <div class="kpi-title">High-Risk Studies</div>
                        <div class="kpi-info" title="Detailed info">
                            <i class="fa fa-info-circle"></i>
                        </div>
                    </div>
                    <div class="kpi-value">3</div>
                    <div class="kpi-trend trend-negative">
                        <i class="fa fa-exclamation-circle"></i>
                        <span>+1 this quarter</span>
                    </div>
                    <div class="progress-labels">
                        <span>12% of portfolio</span>
                    </div>
                </div>
            </div>

            <!-- Study Comparison Section -->
            <!-- <div class="study-comparison-section">
                <div class="section-title">
                    <span>Study Comparison</span>
                    <div class="section-controls">
                        <button class="btn btn-sm btn-outline-danger me-2 py-0" onclick="clearStudySelection()">
                            <i class="fa fa-times"></i> Clear Selection
                        </button>
                        <button class="btn btn-sm btn-outline-primary me-2 py-0" onclick="openDrilldown('comparison')">
                            <i class="fa fa-exchange"></i> Compare Selected
                        </button>
                    </div>
                </div>
                
                <div class="study-selector-grid">
                    <div class="study-card" onclick="toggleStudySelection('COVID-VAX-2024')" data-study="COVID-VAX-2024">
                        <div class="select-indicator"></div>
                        <div class="study-color" style="background-color: var(--study-color-1);"></div>
                        <div class="study-name">COVID-VAX-2024</div>
                        <div class="study-details">
                            <span>Phase 3 | Vaccine</span>
                            <span>42 sites | 68% enrolled</span>
                            <span>Risk: Medium</span>
                        </div>
                    </div>
                    
                    <div class="study-card selected" onclick="toggleStudySelection('ONCO-THERAPY-2023')" data-study="ONCO-THERAPY-2023">
                        <div class="select-indicator">✓</div>
                        <div class="study-color" style="background-color: var(--study-color-2);"></div>
                        <div class="study-name">ONCO-THERAPY-2023</div>
                        <div class="study-details">
                            <span>Phase 3 | Oncology</span>
                            <span>58 sites | 72% enrolled</span>
                            <span>Risk: Low</span>
                        </div>
                    </div>
                    
                    <div class="study-card selected" onclick="toggleStudySelection('NEURO-STUDY-2024')" data-study="NEURO-STUDY-2024">
                        <div class="select-indicator">✓</div>
                        <div class="study-color" style="background-color: var(--study-color-3);"></div>
                        <div class="study-name">NEURO-STUDY-2024</div>
                        <div class="study-details">
                            <span>Phase 2 | Neurology</span>
                            <span>28 sites | 45% enrolled</span>
                            <span>Risk: High</span>
                        </div>
                    </div>
                    
                    <div class="study-card" onclick="toggleStudySelection('CARDIO-TRIAL-2023')" data-study="CARDIO-TRIAL-2023">
                        <div class="select-indicator"></div>
                        <div class="study-color" style="background-color: var(--study-color-4);"></div>
                        <div class="study-name">CARDIO-TRIAL-2023</div>
                        <div class="study-details">
                            <span>Phase 3 | Cardiology</span>
                            <span>36 sites | 82% enrolled</span>
                            <span>Risk: Low</span>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- Dashboard Charts -->
            <div class="chart-grid">
                <div class="modal-chart-container">
                    <div class="section-title mb-0">
                        <span>Enrollment Velocity</span>
                        <button v-if="enrollmentLevel === 'site'" class="btn btn-sm btn-outline-primary py-0"
                            type="button" @click="resetEnrollmentChart">
                            <i class="fa fa-repeat"></i> Reset
                        </button>
                    </div>
                    <div class="desc">Actual vs Planned (%) by Study</div>
                    <div class="modal-chart-wrapper chart-scroll-x">
                        <div class="chart-inner">
                            <canvas id="enrollmentRateChart"></canvas>
                        </div>
                    </div>
                </div>

                <div class="modal-chart-container">
                    <div class="section-title mb-0">
                        <span>Screen Fail Rate</span>

                        <button type="button" class="btn btn-sm btn-outline-primary py-0"
                            v-if="screenFailLevel === 'site'" @click="resetScreenFailChart">
                            <i class="fa fa-repeat"></i> Reset
                        </button>
                    </div>
                    <div class="desc">Screen Fails / Screened (%) — Split by Reason</div>
                    <div class="modal-chart-wrapper chart-scroll-x">
                        <div class="chart-inner">
                            <canvas id="screenFailChart"></canvas>
                        </div>
                    </div>
                </div>

               <div class="modal-chart-container">
  <div class="section-title mb-0 d-flex align-items-center justify-content-between">
    <span>eCRF Completeness{{ ecrfDrillLevel }}</span>

    <button
      v-if="ecrfDrillLevel === 'site'"
      class="btn btn-sm btn-outline-secondary"
      type="button"
      @click="ecrfBackToStudies()"
      style="font-size: 11px; padding: 2px 8px;"
    >
      Back
    </button>
  </div>

  <div class="desc">
    Completed On-Time / Due (%) — Threshold &gt; 95%
    <span v-if="ecrfCurrentTitle" style="margin-left:6px; font-weight:600;">
      | {{ ecrfCurrentTitle }}
    </span>
  </div>

  <div class="modal-chart-wrapper">
    <canvas id="ecrfCompletenessChart"></canvas>
  </div>
</div>


                <div class="modal-chart-container">
                    <div class="section-title mb-0">
                        <span>Query Aging Distribution</span>

                        <button v-if="queryAgingLevel === 'site'" class="btn btn-sm btn-outline-primary py-0"
                            type="button" @click="resetQueryAgingChart">
                            <i class="fa fa-repeat"></i> Reset
                        </button>
                    </div>

                    <div class="desc">0–3d | 4–7d | 8–14d | 15+d</div>
                    <div class="modal-chart-wrapper">
                        <canvas id="queryAgingChart"></canvas>
                    </div>
                </div>

                <div class="modal-chart-container">
                    <div class="section-title mb-0">SDV / SDR Coverage
                        <button v-if="sdvLevel === 'site'" class="btn btn-sm btn-outline-primary py-0" type="button"
                            @click="resetSdvChart">
                            <i class="fa fa-repeat"></i> Reset
                        </button>
                    </div>
                    <div class="desc">Verified / Reviewed vs Required (%) — > 90%</div>


                    <div class="modal-chart-wrapper chart-scroll-x">
                        <div class="chart-inner">
                            <canvas id="sdvCoverageChart"></canvas>
                        </div>
                    </div>
                </div>

                <div class="modal-chart-container">
                    <div class="section-title mb-0">
                        <span>SAE Reporting Timeliness</span>

                        <button v-if="saeLevel === 'site'" class="btn btn-sm btn-outline-primary py-0" type="button"
                            @click="resetSaeChart">
                            <i class="fa fa-repeat"></i> Reset
                        </button>
                    </div>

                    <div class="desc">
                        Median Hours by {{ saeLevel === 'study' ? 'Study' : 'Site' }}
                    </div>

                    <div class="modal-chart-wrapper chart-scroll-x">
                        <div class="chart-inner">
                            <canvas id="saeTimelinessChart"></canvas>
                        </div>
                    </div>
                </div>

            </div>

            <!-- All Studies Table -->
            <!-- <div class="modal-table-container">
                <div class="section-title">
                    <span>All Studies Performance</span>
                    <button class="btn btn-sm btn-outline-primary me-2 py-0" onclick="exportTable()">
                        <i class="fa fa-download"></i> Export
                    </button>
                </div>

                <table class="table table-striped table-bordered dataTables study-protocol-table">
                    <thead>
                        <tr>
                            <th>Study</th>
                            <th>Phase</th>
                            <th>Enrollment</th>
                            <th>Sites Active</th>
                            <th>Screen Failure</th>
                            <th>Risk Level</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr onclick="openDrilldown('study-detail', 'COVID-VAX-2024')">
                            <td><strong>COVID-VAX-2024</strong></td>
                            <td>Phase 3</td>
                            <td>68% (423/588)</td>
                            <td>42/50</td>
                            <td>12.3%</td>
                            <td><span class="status-badge status-warning">Medium</span></td>
                            <td><button class="btn btn-sm btn-outline-primary me-2 py-0"><Small>Compare</Small></button>
                            </td>
                        </tr>
                        <tr onclick="openDrilldown('study-detail', 'ONCO-THERAPY-2023')">
                            <td><strong>ONCO-THERAPY-2023</strong></td>
                            <td>Phase 3</td>
                            <td>72% (520/722)</td>
                            <td>58/65</td>
                            <td>8.5%</td>
                            <td><span class="status-badge status-active">Low</span></td>
                            <td><button class="btn btn-sm btn-outline-primary me-2 py-0"><Small>Compare</Small></button>
                            </td>
                        </tr>
                        <tr onclick="openDrilldown('study-detail', 'NEURO-STUDY-2024')">
                            <td><strong>NEURO-STUDY-2024</strong></td>
                            <td>Phase 2</td>
                            <td>45% (98/218)</td>
                            <td>28/35</td>
                            <td>18.2%</td>
                            <td><span class="status-badge status-critical">High</span></td>
                            <td><button class="btn btn-sm btn-outline-primary me-2 py-0"><Small>Compare</Small></button>
                            </td>
                        </tr>
                        <tr onclick="openDrilldown('study-detail', 'CARDIO-TRIAL-2023')">
                            <td><strong>CARDIO-TRIAL-2023</strong></td>
                            <td>Phase 3</td>
                            <td>82% (360/440)</td>
                            <td>36/40</td>
                            <td>6.8%</td>
                            <td><span class="status-badge status-active">Low</span></td>
                            <td><button class="btn btn-sm btn-outline-primary me-2 py-0"><Small>Compare</Small></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div> -->
        </div>



    </div>
</template>
<script src="./datadashboard.js">
</script>

<style scoped>
@import "./datadashboardstyle.css";
</style>